/**
 * Utility functions for generating unique file names
 */

/**
 * Generate a short unique ID (12 characters)
 * Sufficient for project-level uniqueness
 * @returns {string} A short unique ID
 */
export const generateShortId = () => {
  return Math.random().toString(36).substring(2, 14);
};

/**
 * Generate a unique file name by appending a short ID to the original file name
 * Preserves the original file extension
 * @param {string} originalFileName - The original file name
 * @returns {string} A unique file name with short ID suffix
 */
export const generateUniqueFileName = (originalFileName) => {
  const id = generateShortId();
  
  // Split the file name and extension
  const lastDotIndex = originalFileName.lastIndexOf('.');
  if (lastDotIndex === -1) {
    // No extension
    return `${originalFileName}-${id}`;
  }
  
  const name = originalFileName.substring(0, lastDotIndex);
  const extension = originalFileName.substring(lastDotIndex);
  
  // Return {original_name}-{short_id}{extension}
  return `${name}-${id}${extension}`;
};

/**
 * Rename a File object to have a unique name
 * @param {File} file - The file object to rename
 * @returns {File} A new File object with the renamed file
 */
export const renameFile = (file) => {
  const newFileName = generateUniqueFileName(file.name);
  
  // Create a new File object with the new name
  return new File([file], newFileName, { type: file.type });
};
